<div mat-dialog-title>
  <h2 class="fs__md fw__600">Select a source</h2>
</div>
<div mat-dialog-content class="mat-typography">
  <div class="empathy-editor source-picker__layout">
    <!-- <h3 class="fs__md fw__500">Pick a source</h3>
    <div class="source-picker__sources-library">
      <span>EMPTY</span>
    </div>
    <mat-divider></mat-divider> -->
    <h3 class="fs__md fw__500">New Source</h3>
    <div class="source-picker__new-source">
      <div class="editor-question-form__input">
        <span class="label fs__md">Source Title</span>
        <mat-form-field appearance="outline">
          <input matInput [formControl]="sourceTitle" [errorStateMatcher]="dirtyErrorMatcher" autocomplete="off" />
          @if (sourceTitle.hasError('duplicate')) {
            <mat-error>
              <span class="fs__md fw__500">A source variable with this name already exists</span>
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions>
  <button mat-stroked-button (click)="onClose()">Cancel</button>
  <button mat-flat-button [color]="'primary'" [disabled]="!sourceTitle.value || sourceTitle.invalid" (click)="onContinue()">Select</button>
</div>
